/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCrop54Filled = createReactComponent("filled", "crop-5-4-filled", "IconCrop54Filled", [["path", { "d": "M18 4a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3z", "key": "svg-0" }]]);

export { IconCrop54Filled as default };
//# sourceMappingURL=IconCrop54Filled.mjs.map
